import { render, staticRenderFns } from "./PortfolioGrid.vue?vue&type=template&id=b5044db8&"
import script from "./PortfolioGrid.vue?vue&type=script&lang=js&"
export * from "./PortfolioGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports